import { render, staticRenderFns } from "./A2PCopyBlock.vue?vue&type=template&id=e34b3e90"
import script from "./A2PCopyBlock.vue?vue&type=script&lang=js"
export * from "./A2PCopyBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports